//store/modules/cashouts.js

import axios from './axios'
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
const state = {
  partialCash: {},
}
const getters = {
  partialCash: (state) => state.partialCash,
  cashoutRequestResponse: (state) => state.cashoutRequestResponse,
  validCashout: (state) => state.validCashout,
}
const actions = {
  // /service/fundraiser/eft_details
  async refactorCashout({ commit }, params) {
    let response = await axios.post('/service/withdraw/refactorP', params)
    await commit('setPartialCash', response.data)
  },
  async CashoutMethodChanged({ commit }, req) {
    let response = await axios.post('/portal/fundraiser/update_info', req)
    await commit('setResponse', response.data)
    window.location.reload()
  },
  async sendCashCode({ commit }, cashout) {
    let response = await axios.post('/service/withdraw/confirmP', cashout)
    await commit('setCashout', response.data)
    return response.data
  },
  async verifyCashout({ commit }, cashout) {
    let response = await axios.post('/service/withdraw/verifyP', cashout)
    await commit('setValidCashout', response.data)
    return response.data
  },
  async getBankDetails({ commit }, user) {
    let response = await axios.post('/service/fundraiser/eft_details', user)
    commit('setResponse', response.data)
    return response.data
  },
  async updateBankDetails({ commit }, cashout) {
    let response = await axios.post('/portal/fundraiser/update_info', cashout)
    commit('setResponse', response.data)
    window.location.reload(true)
    return response.data
  },
  async getb2bDetails({ commit }, fund) {
    let response = await axios.post('/service/fundraiser/b2b_details', fund)
    commit('setResponse', response.data)
    return response.data
  },
  async addb2bDetails({ commit }, b2bData) {
    let response = await axios.post('/portal/fundraiser/update_info', b2bData)
    commit('setResponse', response.data)
    return response.data
  },
  async deleteb2bDetails({ commit }, b2bData) {
    let response = await axios.post(
      '/service/fundraiser/pg_b2b_details',
      b2bData,
    )
    commit('setResponse', response.data)
    return response.data
  },
}
const mutations = {
  setValidCashout(state, response) {
    state.validCashout = response
  },
  setCashout(state, response) {
    state.cashoutRequestResponse = response
  },
  setPartialCash(state, response) {
    state.partialCash = response
  },
  setResponse(state, response) {
    state.response = response
  },
}
export default {
  state,
  getters,
  actions,
  mutations,
}
